<template>
	<div style="width: 100%;height: 100%;min-height: 500px;" v-loading="loading">
		<div v-if="equipment == 'pc'">
			<div v-if="data" style="display: flex;align-items: center;margin-top: 20px;font-size: 14px;">
				<div style="display:flex;flex-direction: column;align-items: center;margin-left: 60px;">
					<div>{{$t('h.Balance')}}</div>
					<div style="margin-top: 10px;">{{data.commission_user.balance_format}}</div>
				</div>
				<div style="display:flex;flex-direction: column;align-items: center;margin-left: 60px;">
					<div>{{$t('h.waitAmount')}}</div>
					<div style="margin-top: 10px;">{{data.commission_user.balance_progress_format}}</div>
				</div>
				<div style="display:flex;flex-direction: column;align-items: center;margin-left: 60px;">
					<div>{{$t('h.withdrawaled')}}</div>
					<div style="margin-top: 10px;">{{data.commission_user.withdrawal_balance_format}}</div>
				</div>
				<div style="display:flex;flex-direction: column;align-items: center;margin-left: 60px;">
					<div>{{$t('h.allCommission')}}</div>
					<div style="margin-top: 10px;">{{data.commission_user.total_amount_format}}</div>
				</div>
				<div v-if="data.withdrawal_btn_display == 1">
					<el-button size="mini" type="success" style="margin-left: 60px;" plain
						@click="dialogVisible = true">{{$t('h.withdrawal')}}</el-button>
				</div>
			</div>
			<div style="display: flex;align-items: center;">
				<el-input style="width: 260px;margin-top: 20px;" size="small" v-model="search.q"
					:placeholder="$t('h.orderId')"></el-input>
				<el-date-picker style="margin-top: 20px;margin-left: 20px;" size="small" v-model="search.time"
					type="datetimerange" range-separator="-" :start-placeholder="$t('h.startTime')"
					:end-placeholder="$t('h.endTime')">
				</el-date-picker>
				<el-button size="small" style="margin-left: 20px;margin-top: 19px;"
					@click="searchClick">{{$t('h.search')}}</el-button>
			</div>
		</div>

		<div v-if="equipment == 'phone'">
			<div v-if="data" style="display: flex;margin-top: 20px;font-size: 14px;flex-direction: column;">
				<div style="display:flex;align-items: center;margin-left: 10px;margin-top: 10px;">
					<div>{{$t('h.balance')}}:</div>
					<div style="margin-top: 0px;">{{data.commission_user.balance_format}}</div>
				</div>
				<div style="display:flex;align-items: center;margin-left: 10px;margin-top: 10px;">
					<div>{{$t('h.waitAmount')}}:</div>
					<div style="margin-top: 0px;">{{data.commission_user.balance_progress_format}}</div>
				</div>
				<div style="display:flex;align-items: center;margin-left: 10px;margin-top: 10px;">
					<div>{{$t('h.withdrawaled')}}:</div>
					<div style="margin-top: 0px;">{{data.commission_user.withdrawal_balance_format}}</div>
				</div>
				<div style="display:flex;align-items: center;margin-left: 10px;margin-top: 10px;">
					<div>{{$t('h.allCommission')}}:</div>
					<div style="margin-top: 0px;">{{data.commission_user.total_amount_format}}</div>
				</div>
				<div v-if="data.withdrawal_btn_display == 1">
					<el-button size="mini" type="success" style="margin-left: 10px;" plain
						@click="dialogVisible = true">{{$t('h.withdrawal')}}</el-button>
				</div>
			</div>
			<div style="display: flex;flex-direction: column;">
				<el-input style="width: 90%;margin-top: 20px;" size="small" v-model="search.q"
					:placeholder="$t('h.orderId')"></el-input>
				<!-- <el-date-picker style="margin-top: 20px;margin-left: 20px;" size="small" v-model="search.time"
					type="datetimerange" range-separator="-" :start-placeholder="$t('h.startTime')" :end-placeholder="$t('h.endTime')">
				</el-date-picker> -->
				<div style="display: flex;align-items: center;width: 90%;margin-top: 10px;overflow: hidden;">
					<el-date-picker @change="changePhoneTimeStart" size="small" style="width: 50%;" type="datetime"
						v-model="phoneTime1" :placeholder="$t('h.startTime')">
					</el-date-picker>
					<el-date-picker @change="changePhoneTimeEnd" style="margin-left: 10px;width: 50%;" size="small"
						v-model="phoneTime2" type="datetime" :placeholder="$t('h.endTime')">
					</el-date-picker>
				</div>

				<el-button size="small" style="margin-top: 19px;width: 90%;"
					@click="searchClick">{{$t('h.search')}}</el-button>
			</div>
		</div>

		<div v-if="data" style="overflow-x: hidden;" :style="{
			width: equipment == 'pc'?'100%':'88vw'
		}">
			<el-table :data="data.logs.data" style="width: 100%;margin-top: 20px;">
				<el-table-column prop="order_id" :label="$t('h.orderId')" width="180">
				</el-table-column>
				<el-table-column prop="level" :label="$t('h.rebateLevel')" width="180">
				</el-table-column>
				<el-table-column prop="rate2" :label="$t('h.CommissionRate')">
				</el-table-column>
				<el-table-column prop="c_amount" :label="$t('h.commission')">
				</el-table-column>
				<el-table-column prop="status_format" :label="$t('h.settlementStatus')">
				</el-table-column>
				<el-table-column prop="date_at" :label="$t('h.time')">
				</el-table-column>
			</el-table>
		</div>
		<el-pagination @current-change="currentChange" v-if="data" style="margin-top: 20px;" layout="prev, pager, next"
			:total="data.logs.total">
		</el-pagination>
		<el-dialog v-if="data" :label="$t('h.tips')" :visible.sync="dialogVisible" :width="equipment == 'pc'?'30%':'96%'"
			:before-close="()=>{dialogVisible = false}">
			<div style="display: flex;align-items: center;">
				<div>{{$t('h.WithdrawalAmount')}}</div>
				<el-input-number style="margin-left: 20px;" size="small" :min="1"
					:max="data.commission_user.balance / 100" v-model="form.money" :step="1"></el-input-number>
			</div>
			<div style="display: flex;align-items: center;margin-top: 20px;">
				<div>{{$t('h.withdrawalUser')}}</div>
				<el-select @change="changeBank" style="margin-left: 20px;" size="mini" v-model="form.bankId"
					:placeholder="$t('h.peleaseSelect')">
					<el-option v-for="(item,index) in data.withdrawal_groups" :key="index" :label="item.name"
						:value="item.id">
					</el-option>
				</el-select>
			</div>
			<div v-for="(item,index) in bankList" :key="index">
				<div style="align-items: center;margin-top: 20px;">
					<div style="width: 70px;">{{item.description.content}}</div>
					<el-input style="width: 260px;margin-left: 20px;margin-top: 10px;" size="mini" v-model="item.value"
						:placeholder="$t('h.peleaseIpt')"></el-input>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false" class="btn">{{$t('h.cancel')}}</el-button>
				<el-button :loading="btnLoading" style="background-color: #000;border: solid 1px #000;" type="primary"
					@click="cashApply">{{$t('h.confirm')}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getCommissionCashapply,
		getCommissionShopOrders
	} from '../../../../api/all.js'
	import en from 'element-ui/lib/locale/lang/en'
	import zh_cn from 'element-ui/lib/locale/lang/zh-CN'
	import de from 'element-ui/lib/locale/lang/de'
	import es from 'element-ui/lib/locale/lang/es'
	import fr from 'element-ui/lib/locale/lang/fr'
	import id from 'element-ui/lib/locale/lang/id'
	import it from 'element-ui/lib/locale/lang/it'
	import ja from 'element-ui/lib/locale/lang/ja'
	import ko from 'element-ui/lib/locale/lang/ko'
	import ru from 'element-ui/lib/locale/lang/ru-RU'
	import locale from 'element-ui/lib/locale'
	export default {
		props: {
			equipment: {
				type: String,
				default: "pc"
			},
			localPageData: {
				type: Object,
				default: () => {
					return {}
				}
			},
			userInfo: {
				type: Object,
				default: () => {
					return {}
				}
			},

		},
		data() {
			return {
				phoneTime1: "",
				phoneTime2: "",
				lang: {
					en,
					zh_cn,
					de,
					es,
					fr,
					id,
					it,
					ja,
					ko,
					ru
				},
				btnLoading: false,
				bankList: [],
				form: {
					money: 1,
					bankId: '',

				},
				dialogVisible: false,
				loading: false,
				data: null,
				search: {
					page: 1,
					pageSize: 10,
					q: "",
					start_at: "",
					end_at: "",
					time: ""

				}
			}
		},
		async mounted() {
			locale.use(this.lang[localStorage.getItem("locale")])
			await this.getData()
		},
		methods: {
			changePhoneTimeStart(e) {
				console.log('e', e)
				this.search.start_at = this.getTime(e)
			},
			changePhoneTimeEnd(e) {
				console.log('e', e)
				this.search.end_at = this.getTime(e)
			},
			async cashApply() {
				this.btnLoading = true
				try {
					let data = await getCommissionCashapply({
						amount: this.form.money,
						withdrawal_id: this.form.bankId,
						withdrawal_group_items: this.bankList

					})
					this.btnLoading = false
					this.dialogVisible = false
					this.$message.success(this.$t('h.submitSuccess'))
				} catch (e) {
					console.log('e', e)
					this.btnLoading = false

				}

			},
			changeBank(e) {
				console.log('e', e)
				this.data.withdrawal_groups.forEach(item => {
					if (item.id == e) {
						this.bankList = item.items
					}
				})
				this.$forceUpdate()
			},
			async currentChange(e) {
				this.search.page = e
				await this.getData()
			},
			getTime(time) {
				var date = new Date(time);
				//下面语句判断，当月份小于10月时，前面位0
				var Y = date.getFullYear(); //获取当前年份
				var M = date.getMonth() + 1; //获取当前月份
				var D = date.getDate(); //获取当前日 
				var hour = date.getHours(); //获取当前时
				var min = date.getMinutes(); //获取当前分
				var second = date.getSeconds(); //获取当前秒
				//判断月份
				if (M < 10) {
					M = '0' + M;
				}
				//判断日
				if (D < 10) {
					D = '0' + D;
				}
				//判断小时
				if (hour < 10) {
					hour = '0' + hour;
				}
				//判断分钟   
				if (min < 10) {
					min = '0' + min;
				}
				//判断秒
				if (second < 10) {
					second = '0' + second;
				}
				return Y + "-" + M + "-" + D + "+" + hour + ":" + min + ":" + second;
			},

			async searchClick() {
				console.log(this.search.time)
				if (this.search.time && this.search.time.length > 0) {
					console.log(this.getTime(this.search.time[0]))
					this.search.start_at = this.getTime(this.search.time[0])
					this.search.end_at = this.getTime(this.search.time[1])
				} else {
					this.search.start_at = ""
					this.search.end_at = ""
				}
				await this.getData()


			},
			async getData() {
				try {
					this.loading = true
					let obj = {}
					for (let i in this.search) {
						if (this.search[i] != '' && i != 'time') {
							obj[i] = this.search[i]
						}
					}
					const data = await getCommissionShopOrders(obj)
					console.log('data', data)
					this.data = data.data
					this.loading = false
				} catch (e) {
					this.loading = false
				}

			}
		}
	}
</script>

<style lang="scss" scoped>
	.btn:hover {
		background-color: #ffffff;
		color: #000000;
		border: solid 1px #949494;
	}

	.btn:focus {
		background-color: #ffffff;
		border: solid 1px #949494;
		color: #000000;
	}
</style>